<template>
	<Box v-if="show" class="alert-boost">
		<div class="alert-boost-icon">
			<font-awesome-icon class="icon" :icon="['fal', 'phone-plus']" />
		</div>
		<div>
			<div class="alert-boost-heading">Boost - UWM's Growth Marketplace</div>
			<p class="alert-boost-message">
				Boost provides you with streamlined access to a variety of tools and
				resources that give you access to leads from past and prospective
				clients as well as real estate agents so you can continue to grow and
				manage your business more effectively.
			</p>
			<br />
			<p class="alert-boost-message">
				<a href="https://www.clientconvert.com" target="_blank"> Click here </a>
				to sign up and manage your Boost account.
			</p>
		</div>
	</Box>
</template>

<script>
import Badge from '@/components/global/Badge.vue';
import Box from '@/components/global/Box.vue';

export default {
	name: 'AlertBoost',
	components: {
		Badge,
		Box,
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.alert-boost {
	display: flex;
	align-items: flex-start;
	@include rem(margin-bottom, 20px);
	@include rem('padding', 30px 15px);

	a {
		text-decoration: underline;
	}

	.alert-boost-heading {
		@include rem('margin-bottom', 4px);
		@include typo--roboto__medium;
		font-weight: bold;
		display: flex;
		.badge {
			@include rem('margin-left', 8px);
		}
	}

	/* The following p:not(.description) styles are to reset the global styles for this component only */
	p:not(.description) {
		margin-top: unset;
		margin-bottom: unset;
		line-height: unset;
	}

	p:not(.description):last-of-type {
		margin-bottom: unset;
		padding-bottom: unset;
	}

	p.alert-boost-message {
		line-height: 1.5;
		margin-bottom: 0;
	}

	.alert-boost-icon {
		flex: 0 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
		@include rem('width', 44px);
		@include rem('height', 44px);
		@include rem('margin-right', 15px);
		@include rem('font-size', 20px);
		border-radius: 8px;
		border: $b360-border-width-thin solid $border-color-light;
		background: $white;
		svg {
			transform: scaleX(-1);
		}
	}
}
</style>
